import React from 'react';
import classNames from 'classnames';

const Loader = ({ show, noOverlay = false }) => show && (
    <div
        className={classNames({
            'loader-container': noOverlay,
            'full-screen-container': !noOverlay,
        })}
    >
        <div className="loader" />
    </div>
);

export default Loader;